import { StyleSheet } from 'react-native';
import { PALETTE, SIZES, MQ_TABLET } from '../../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import theme from '@dbk/ui-theme';

export default MediaQueryStyleSheet.create({
  chartTitle: {
    marginTop: 15,
    marginBottom: 15,
    marginLeft: SIZES.appHorizontalSpace,
  },
  timechartWrapper: {
    flex: 1,
    paddingBottom: 20,
    backgroundColor: theme.paletteDawnBlue,
  }
}, {
	[MQ_TABLET]:{
	  timechartWrapper: {
      flex: 0.5,
      backgroundColor: theme.paletteDawnBlue,
	  }
	}
});

export const axisSVGStyles = {
  color: theme.paletteInverseTertiaryText,
  stroke: theme.paletteInverseTertiaryText,
};
